<clr-wizard
    #wizard
    class="update-wizard"
    clrWizardSize="xl"
    [(clrWizardOpen)]="isWizardOpen"
    [clrWizardClosable]="true"
    (clrWizardOnCancel)="handleClose()"
    (clrWizardOnClose)="handleClose()"
    [clrWizardPreventDefaultNext]="true"
    [clrWizardDisableStepnav]="true"
>
    <clr-wizard-title>{{ wizardTitle }}</clr-wizard-title>

    <clr-wizard-button
        type="cancel"
        (click)="handleClose()"
    >
        {{ globalL10nKeys.cancelLabel | vtranslate }}
    </clr-wizard-button>
    <clr-wizard-button type="next">
        {{ l10nKeys.startButtonLabel | vtranslate }}
    </clr-wizard-button>
    <clr-wizard-page
        #selectSegUpdatePage
        *ngIf="!isSystemUpdate"
    >
        <ng-template clrPageTitle>
            {{ l10nKeys.selectUpdateLabel | vtranslate }}
        </ng-template>
        <div class="update-wizard-container">
            <seg-image-selection
                *ngIf="!isSystemUpdate && segUpgradeNodeList?.length && isWizardOpen"
                [segUpgradeNodeList]="segUpgradeNodeList"
                (onConfirm)="onSegImageSelection($event)"
            ></seg-image-selection>
        </div>
        <ng-template clrPageButtons>
            <clr-wizard-button type="cancel">{{ globalL10nKeys.closeLabel | vtranslate }}</clr-wizard-button>
            <cds-button
                [disabled]="!upgradeConfig?.upgradeType"
                (click)="handleSegUpdateSelection()"
                size="md"
            >
                {{ l10nKeys.nextButtonLabel | vtranslate }}
            </cds-button>
        </ng-template>
    </clr-wizard-page>
    <clr-wizard-page
        (clrWizardPageNext)="handleSubmit()"
        [clrWizardPageNextDisabled]="isLetsBeginPageDisabled"
        #letsBeginPage
    >
        <ng-template clrPageTitle>
            {{ l10nKeys.letsBeginLabel | vtranslate }}
        </ng-template>
        <div class="update-wizard-container">
            <avi-alert-group
                *ngIf="error"
                alertType="danger"
                class="update-wizard__alert-group"
            >
                {{ error }}
            </avi-alert-group>

            <clr-spinner
                *ngIf="busy"
                clrMedium
            ></clr-spinner>

            <ng-container *ngIf="!busy">
                <ng-template
                    #segActionOnErrorRadio
                    let-extraDisabled="extraDisabled"
                >
                    <avi-radio-container>
                        <label
                            aviLabelWithTooltip
                            for="action-on-error"
                        >
                            {{ l10nKeys.actionTakeLabel | vtranslate }}
                        </label>
                        <avi-radio
                            *ngFor="let enumValue of segErrorRecoveryEnumValues; trackBy: trackByEnumValue"
                            name="action-on-error"
                            id="action-on-error"
                            [value]="enumValue.value"
                            [disabled]="extraDisabled || enumValue.value === seGroupErrorRecoveryEnumHash.ROLLBACK_UPGRADE_OPS_ON_ERROR"
                            [(ngModel)]="actionOnSegFailure"
                        >
                            <!-- TODO: Update this once proto-buf file is updated -->
                            {{ enumValue.label.split(' ')[0] }}
                        </avi-radio>
                    </avi-radio-container>
                </ng-template>
                <ng-container *ngIf="isRestore; else updateOperations">
                    <div class="file-upload-wrapper">
                        <div class="file-upload-wrapper__file">
                            <label
                                aviLabelWithTooltip
                                tooltipText="{{ l10nKeys.uploadBackupFileLabel | vtranslate }}"
                                for="restore-backup-file"
                            >
                                {{ l10nKeys.uploadBackupFileLabel | vtranslate }}
                            </label>
                            <file-upload
                                [(ngModel)]="restoreFile"
                                id="restore-backup-file"
                                [decodeFile]="false"
                                name="restore-backup-file"
                                [required]="true"
                            ></file-upload>
                        </div>
                        <avi-input-container>
                            <label
                                aviLabelWithTooltip
                                fieldName="passphrase"
                                for="passphrase"
                            >
                                {{ l10nKeys.passphraseLabel | vtranslate }}
                            </label>
                            <input
                                name="passphrase"
                                id="passphrase"
                                type="password"
                                clrInput
                                placeholder="{{ l10nKeys.passphraseLabel | vtranslate }}"
                                [(ngModel)]="passphrase"
                            />
                        </avi-input-container>
                    </div>
                </ng-container>

                <ng-template #updateOperations>
                    <label
                        aviLabelWithTooltip
                        class="update-wizard__question-label"
                    >
                        {{ l10nKeys.optionsQuestionLabel | vtranslate }}
                    </label>
                    <div class="update-wizard__option-container">
                        <avi-card
                            class="update-wizard__option"
                            *ngIf="isRollback"
                        >
                            <avi-card_header>
                                <avi-radio-container [noMarginTop]="true">
                                    <avi-radio
                                        name="upgrade-option"
                                        id="system-rollback"
                                        [(ngModel)]="upgradeType"
                                        [value]="UpgradeType.UPGRADE_TYPE_SYSTEM_ROLLBACK"
                                    >
                                        {{ l10nKeys.rollbackBtnLabel | vtranslate }}
                                    </avi-radio>
                                </avi-radio-container>
                            </avi-card_header>
                            <avi-card_body>
                                {{ l10nKeys.rollbackDescription | vtranslate }}
                            </avi-card_body>
                        </avi-card>
                        <avi-card
                            class="update-wizard__option"
                            *ngIf="!isRollback"
                        >
                            <avi-card_header>
                                <avi-radio-container [noMarginTop]="true">
                                    <avi-radio
                                        name="upgrade-option"
                                        id="system-upgrade"
                                        [(ngModel)]="upgradeType"
                                        [value]="isSystemUpdate ? UpgradeType.UPGRADE_TYPE_SYSTEM_UPGRADE: UpgradeType.UPGRADE_TYPE_SEG_UPGRADE"
                                    >
                                        {{ l10nKeys.updateLabel | vtranslate }}
                                    </avi-radio>
                                </avi-radio-container>
                            </avi-card_header>
                            <avi-card_body>
                                {{ l10nKeys.updateDescription | vtranslate }}
                            </avi-card_body>
                        </avi-card>
                        <avi-card class="update-wizard__option">
                            <avi-card_header>
                                <avi-radio-container [noMarginTop]="true">
                                    <avi-radio
                                        name="upgrade-option"
                                        id="system-precheck"
                                        [(ngModel)]="upgradeType"
                                        [value]="isSystemUpdate ? UpgradeType.UPGRADE_TYPE_SYSTEM_PRECHECK: UpgradeType.UPGRADE_TYPE_SEG_PRECHECK"
                                    >
                                        {{ l10nKeys.preCheckOnlyLabel | vtranslate }}
                                    </avi-radio>
                                </avi-radio-container>
                            </avi-card_header>
                            <avi-card_body>
                                {{ l10nKeys.preCheckDescription | vtranslate }}
                            </avi-card_body>
                        </avi-card>
                        <avi-card
                            class="update-wizard__option"
                            *ngIf="!isRollback && isSystemUpdate"
                        >
                            <avi-card_header>
                                <avi-radio-container [noMarginTop]="true">
                                    <avi-radio
                                        name="upgrade-option"
                                        id="system-dryrun"
                                        [(ngModel)]="upgradeType"
                                        [value]="UpgradeType.UPGRADE_TYPE_SYSTEM_DRYRUN"
                                    >
                                        {{ l10nKeys.dryRunLabel | vtranslate }}
                                    </avi-radio>
                                </avi-radio-container>
                            </avi-card_header>
                            <avi-card_body>
                                {{ l10nKeys.dryRunDescription | vtranslate }}
                            </avi-card_body>
                        </avi-card>
                    </div>
                    <div
                        class="update-wizard__seg-check"
                        *ngIf="showUpgradeSegCheckbox"
                    >
                        <avi-checkbox
                            *ngIf="showUpgradeSegCheckbox"
                            objectType="{{ objectTypes.UpgradeParams }}"
                            fieldName="system"
                            id="upgrade-system"
                            [(ngModel)]="applyToSystem"
                            (ngModelChange)="handleApplyToSystemChange()"
                            name="upgrade-system"
                        >
                            {{ (isUpgradeMode ? l10nKeys.updateCheckboxLabel : l10nKeys.rollbackCheckboxLabel) | vtranslate }}
                        </avi-checkbox>
                        <div *ngIf="isUpgradeMode && isSegUpgradeAvailable && applyToSystem">
                            <cds-divider class="update-wizard__cds-divider"></cds-divider>
                            <div class="full-modal-config__form-control-row">
                                <div class="full-modal-config__form-control">
                                    <label
                                        aviLabelWithTooltip
                                        for="seg-system-upgrade-patch-dropdown"
                                    >
                                        {{ l10nKeys.seGroupPatchVersionLabel | vtranslate }}
                                    </label>
                                    <avi-dropdown
                                        name="seg-system-upgrade-patch-dropdown"
                                        id="seg-system-upgrade-patch-dropdown"
                                        [options]="segSystemUpgradePatchVersionOptions"
                                        [disabled]="!applyToSystem || !this.segSystemUpgradePatchVersionOptions.length"
                                        [required]="!initialSystemImageId"
                                        [(ngModel)]="selectedSegSystemUpgradePatchImageId"
                                        (ngModelChange)="handleSelectedSegSystemUpgradeVersionChange()"
                                    >
                                    </avi-dropdown>
                                </div>
                            </div>
                            <ng-container
                                *ngTemplateOutlet="segActionOnErrorRadio; context: { extraDisabled: !applyToSystem }"
                            ></ng-container>
                        </div>
                    </div>
                    <div 
                        class="update-wizard__seg-check"
                        *ngIf="!isSystemUpdate"
                    >
                        <ng-container
                            *ngTemplateOutlet="segActionOnErrorRadio; context: { extraDisabled: false }"
                        ></ng-container>
                    </div>
                </ng-template>

                <div class="update-wizard__check-list">
                    <clr-accordion>
                        <clr-accordion-panel [clrAccordionPanelOpen]="true">
                            <clr-accordion-title>
                                {{ l10nKeys.recommendCheckMessage | vtranslate }}
                            </clr-accordion-title>
                            <clr-accordion-content>
                                <ul class="update-wizard__check-list-content">
                                    <li
                                        *ngFor="let check of previewCheckList; trackBy: trackByIndex"
                                        class="update-wizard__check-list-item"
                                    >
                                        <cds-icon
                                            status="success"
                                            shape="check-circle"
                                            size="20"
                                        >
                                        </cds-icon>
                                        <span>
                                            {{ check | trimSingleQuote }}
                                        </span>
                                    </li>
                                </ul>
                            </clr-accordion-content>
                        </clr-accordion-panel>
                    </clr-accordion>
                </div>
            </ng-container>
        </div>
    </clr-wizard-page>
    <clr-wizard-page #preCheckPage>
        <ng-template clrPageTitle>{{ l10nKeys.preCheckLabel | vtranslate }}</ng-template>
        <precheck-wizard-page
            *ngIf="preCheckProgressConfig"
            [upgradeNodeCollection]="preCheckProgressConfig?.upgradeNodeCollection"
            [readonly]="preCheckProgressConfig?.readonly"
            [selectedSegIds]="selectedSegIds"
            (onPreCheckCompletion)="handleCurrentPreChecksState($event)"
            (onGoToReportPage)="handleGoToReportPage()"
        ></precheck-wizard-page>
        <div *ngIf="isSuppressWarningEnabled">
            <avi-checkbox
                name="suppress-warning"
                [(ngModel)]="suppressWarning"
            >
                {{ l10nKeys.suppressWarningHeader | vtranslate }}
            </avi-checkbox>
        </div>
        <ng-template clrPageButtons>
            <clr-wizard-button type="cancel">{{ globalL10nKeys.closeLabel | vtranslate }}</clr-wizard-button>
            <cds-button
                *ngIf="isSuppressWarningEnabled"
                [disabled]="!suppressWarning"
                (click)="handlePreChecksPageButtonClick()"
                (keypress)="handlePreChecksPageButtonClick()"
                (keydown)="handlePreChecksPageButtonClick()"
                (keyup)="handlePreChecksPageButtonClick()"
                size="md"
            >
                {{ l10nKeys.retriggerPreChecksLabel | vtranslate }}
            </cds-button>
        </ng-template>
    </clr-wizard-page>
    <clr-wizard-page *ngIf="upgradeType === UpgradeType.UPGRADE_TYPE_SYSTEM_UPGRADE || upgradeType === UpgradeType.UPGRADE_TYPE_SEG_UPGRADE">
        <ng-template clrPageTitle>{{ l10nKeys.updateLabel | vtranslate }}</ng-template>
    </clr-wizard-page>
    <clr-wizard-page *ngIf="upgradeType === UpgradeType.UPGRADE_TYPE_SYSTEM_RESTORE">
        <ng-template clrPageTitle>{{ l10nKeys.restoreLabel | vtranslate }}</ng-template>
    </clr-wizard-page>
    <clr-wizard-page *ngIf="upgradeType === UpgradeType.UPGRADE_TYPE_SYSTEM_DRYRUN">
        <ng-template clrPageTitle>{{ l10nKeys.dryRunLabel | vtranslate }}</ng-template>
    </clr-wizard-page>
    <clr-wizard-page *ngIf="upgradeType === UpgradeType.UPGRADE_TYPE_SYSTEM_ROLLBACK">
        <ng-template clrPageTitle>{{ l10nKeys.rollbackBtnLabel | vtranslate }}</ng-template>
    </clr-wizard-page>
</clr-wizard>
